import { Button } from "@/components/ui/button";
import { useLeadFunnel } from "@/contexts/LeadFunnelContext";
import heroAfter from "@/assets/hero-after-driveway.jpg";

export const HeroAfter = () => {
  const { open } = useLeadFunnel();
  const scrollToWork = () => {
    document.getElementById("proof")?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <section id="top" className="bg-charcoal text-warm-white">
      <div className="grid lg:grid-cols-2 items-stretch min-h-[80vh]">
        <div className="flex items-center px-6 lg:px-16 py-20 lg:py-28 animate-fade-in">
          <div className="max-w-xl">
            <h1 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] uppercase">
              Clean Work.
              <br />
              <span className="text-brass">Clear Results.</span>
            </h1>
            <p className="mt-6 text-base md:text-lg text-warm-white/75 leading-relaxed">
              Debris removal, property turnovers, and exterior builds executed with precision.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-3">
              <Button variant="brass" size="xl" onClick={open}>
                Get a Quote
              </Button>
              <Button variant="outlineLight" size="xl" onClick={scrollToWork}>
                View Work
              </Button>
            </div>
          </div>
        </div>
        <div className="relative overflow-hidden bg-charcoal-soft min-h-[50vh] lg:min-h-full">
          <img
            src={heroAfter}
            alt="Pristine clean residential driveway after professional cleanup"
            width={1280}
            height={1280}
            fetchPriority="high"
            decoding="async"
            className="h-full w-full object-cover transition-transform duration-700 ease-out lg:hover:scale-[1.03]"
          />
        </div>
      </div>
    </section>
  );
};
